import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const CategoriesSelector = ({ categories = [], value = [], onChange, label, placeholder = 'Todas' }) => {
  const { t } = useTranslation()

  return (
    <div>
      <ComboBox
        menuItems={categories?.map(c => ({ label: c.name, value: c.id }))}
        value={value || []}
        multiple
        fullWidth
        label={label || t('Categoría')}
        handleChange={e => onChange(e.target.value)}
        placeholder={placeholder || t('Todas')}
      />
    </div>
  )
}

export default CategoriesSelector
